import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { DatepickerRange } from '@xsolla/ui-calendar';
import { FieldRow, Select } from '@xsolla/ui-core';

import { Period } from '../../../hooks/types';
import { ALL_PROJECTS_COUNTRIES } from '../../../hooks/useAnalyticsData';
import { periods } from '../../../pages/Analytics';
// import countryData from '../../ui/PhoneInput/country-data';
import { SelectorsProps } from '../types';
import { FieldGroupWrapper, LabelWrapper, SelectorsWrapper } from './style';

const AnalyticsSelectors = ({
  loginProjects,
  updateAnalytics,
  selectedLogin,
  selectedDate,
  selectedCountry
}: SelectorsProps): JSX.Element => {
  const intl = useIntl();
  const selectProjects = useMemo(() => {
    return [
      {
        name: intl.formatMessage({ id: 'analytics.selectors.all-logins.placeholder' }),
        id: ALL_PROJECTS_COUNTRIES
      }
    ]
      .concat(loginProjects)
      .map((item) => ({
        children: item?.name || item.id,
        value: item.id
      }));
  }, [loginProjects]);

  /*
  const selectCountries = useMemo(() => {
    return Object.keys(countryData).map((country) => ({
      children: intl.formatMessage({ id: `form.select.country-name.${country}` }),
      value: country
    }));
  }, [countryData]);
 */
  const changeDatepicker = useCallback(
    (value: Period) => {
      if (value.from && selectedDate !== value) {
        updateAnalytics({
          datePeriod: value,
          loginProject: selectedLogin,
          country: selectedCountry
        });
      }
    },
    [selectedLogin, selectedDate, selectedCountry]
  );

  const selectLogin = useCallback(
    (value: string | null) => {
      if (selectedLogin !== value) {
        updateAnalytics({
          datePeriod: selectedDate,
          loginProject: value,
          country: selectedCountry
        });
      }
    },
    [selectedLogin, selectedDate, selectedCountry]
  );

  /*
  const selectCountry = useCallback(
    (value: string | null) => {
      if (selectedCountry !== value) {
        updateAnalytics({
          datePeriod: selectedDate,
          loginProject: selectedLogin,
          country: value
        });
      }
    },
    [selectedLogin, selectedDate, selectedCountry]
  );
  */
  return (
    <FieldRow align="center" gap="lg" justify="space-between" stretched>
      <DatepickerRange
        data-test-id="analytics-page__datepicker"
        placeholder={intl.formatMessage({ id: 'analytics.selectors.date.placeholder' })}
        onChange={changeDatepicker}
        value={selectedDate}
        options={{
          initialMonth: new Date(),
          numberOfMonths: 2,
          disabledDays: {
            after: periods.last60days.to
          }
        }}
      />

      <SelectorsWrapper>
        <FieldGroupWrapper>
          <LabelWrapper>
            {intl.formatMessage({ id: 'analytics.selectors.all-logins.title' })}
          </LabelWrapper>
          <Select
            data-test-id="analytics-page__project-selector"
            options={selectProjects}
            placeholder={intl.formatMessage({
              id: 'analytics.selectors.all-logins.placeholder'
            })}
            onChange={selectLogin}
            size="sm"
            value={selectedLogin}
          />
        </FieldGroupWrapper>
        {/*
        <FieldGroupWrapper>
          <LabelWrapper>
            {intl.formatMessage({ id: 'analytics.selectors.all-countries.title' })}
          </LabelWrapper>
          <Select
            options={selectCountries}
            placeholder={intl.formatMessage({
              id: 'analytics.selectors.all-countries.placeholder'
            })}
            onChange={selectCountry}
            size="sm"
            value={selectedCountry}
          />
        </FieldGroupWrapper>
        */}
      </SelectorsWrapper>
    </FieldRow>
  );
};

export default AnalyticsSelectors;
